import { Medarbeider } from "../auth/myProfilesWithData";
import { BackendResponse } from "../BackendResponse";
import { withNextApi } from "../nextApiHelpers";

export interface GetDetailsForCandidateResponse
  extends BackendResponse,
    Medarbeider {}

export const getDetailsForCandidate =
  withNextApi<GetDetailsForCandidateResponse>("/cvp/CvpGetCandidate");
